import React from 'react';

export const serializers = {
	marks: {
		link: ({ children, mark }) => {
			const openInNewTab = mark.openInNewTab === true;
			return (
				<a
					target={openInNewTab ? '_blank' : '_self'}
					rel={openInNewTab ? 'noopener noreferrer' : undefined}
					href={mark.href}
				>
					{children}
				</a>
			);
		},
		fontAdjustments: ({ children }) => {
			console.log('Unknown mark - fontAdjustments: ', children);
		},
	},
};
